// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0

/**
 * Merges two arrays of objects. (マージして、同じObjだったら、置き換える)
 * @param {[]} original Original array data.
 * @param {[]} newdata New array data to be appended to original
 * @param {string} uniqueSelector attribute key to select unique elements.
 */
export const mergeArrayOfObjects = <T>(
  original: T[],
  newdata: T[],
  uniqueSelector: keyof T
) => {
  newdata.forEach((dat) => {
    let foundIndex = 0;
    let firstIndex = -1;
    while (foundIndex !== -1) {
      foundIndex = original.findIndex(
        (ori) => ori[uniqueSelector] === dat[uniqueSelector]
      );
      if (foundIndex >= 0) {
        if (firstIndex === -1) firstIndex = foundIndex;
        original.splice(foundIndex, 1);
      }
    }
    if (firstIndex >= 0) {
      original.splice(firstIndex, 0, dat);
    } else {
      original.push(dat);
    }
  });

  return [...original];
};

/**
 * Merges two arrays of objects. (マージして、同じObjだったら、元Objに上書きする)
 * @param {[]} original Original array data.
 * @param {[]} newdata New array data to be appended to original
 * @param {string} uniqueSelector attribute key to select unique elements.
 */
export const mergeAndOverrideArrayOfObjects = <T>(
  original: T[],
  newdata: T[],
  uniqueSelector: keyof T
) => {
  original.forEach((originalElement) => {
    let newdataElement = newdata.find((newdataEl) => {
      return originalElement[uniqueSelector] === newdataEl[uniqueSelector];
    });
    newdataElement
      ? Object.assign(newdataElement, originalElement)
      : newdata.push(originalElement);
  });

  return [...newdata];
};
